module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAFRSURBVDiNzdTNTcMwFMDx/3PtcM0IbECZgORKqNRuUDagE7BCNyhMgFAVzt2AbEBHyBHVbh6H0AKiJC4XeCfLT+/nD/kZ/nvIblAm9gEY9xYo80sfZgClG0wVk155P9/lbZtwQ1QzkPON93WPWb9jC4RM0Lp0g7PCb6/3YKOaGqN1sQlVzLFaTKYNOgmbsEqcfVlaez8KYWVjgO8YmShzgyxOnL1TIIR2M+Y32MZs80sfZgqVwhQkn7xfRTT4GZu8si4TeyswBMkL7/dXFQUewlBuQPJGmtPSDRbRYBdWeF8ZJVXkNArsww7V/Agurc0Qme7xCIzdOzy4kuEC1TtE1snWPrez3VgnKEqmIinKGNEaNZM+rBNskEfRpgZTtR207bO6wY+Gj4O+gypp6dww4nP4EoKcIexrLMAohNWTs5WKPifJce2t6Lpp5Pqooj+NN2mKsKppgR+jAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/xiugai.png
// module id = kvvd
// module chunks = 1